import { createApp } from 'vue'
// import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import "./jwt-interceptor";
import "./assets/css/sqops.scss"
import gAuthPlugin from 'vue3-google-oauth2';

loadFonts()

// createApp(App)
//   .use(router)
//   .use(store)
//   .use(vuetify)
//   .use(Vuex)
//   .mount('#app')

const app = createApp(App);

const gauthClientId = '496524171751-cljruc38g6t98ofr55gkniqi1jc20mae.apps.googleusercontent.com';
app.use(gAuthPlugin, {
  clientId: gauthClientId,
  scope: 'email',
  prompt: 'consent',
})

app.use(router);
app.use(store);
app.use(vuetify);
// app.use(Vuex);
app.mount('#app');
